import axios from "axios";
import { devApiUrl } from "../config";

/**
 * Tests a file by notifying the backend to process it after all chunks are uploaded.
 *
 * @param {string} dataModelId - The ID of the data model associated with the file.
 * @param {string} fileName - The name of the file to be tested.
 * @param {string} accordionId - The ID of the accordion component associated with the file.
 * @returns {Promise<object>} A promise that resolves with the response from the backend.
 */
export const testFileOnBackend = async (dataModelId, fileName, accordionId) => {
  try {
    // Construct the API endpoint
    const apiUrl = `${devApiUrl}/test-file`;

    // Prepare the request body
    const requestBody = {
      fileName,
      dataModelId,
      accordionId,
    };

    // Make the POST request to the backend
    const testedFileResponse = await axios.post(apiUrl, requestBody);

    // Return the response received from the backend
    return testedFileResponse.data;
  } catch (error) {
    // Handle errors (e.g., network issues, invalid parameters)
    console.error("Error in testFile function:", error.message);
    throw error; // Rethrow the error for the caller to handle if needed
  }
};
